@if(!isLoading){
    <agent-shell [available]="agentAvailable()">
        <router-outlet></router-outlet>
        <agent-dock agent-content></agent-dock>
    </agent-shell>
    <span class="version">{{version}}</span>
}